import { render, staticRenderFns } from "./Customizer.vue?vue&type=template&id=999060de&scoped=true&"
import script from "./Customizer.vue?vue&type=script&lang=js&"
export * from "./Customizer.vue?vue&type=script&lang=js&"
import style0 from "./Customizer.vue?vue&type=style&index=0&id=999060de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "999060de",
  null
  
)

component.options.__file = "Customizer.vue"
export default component.exports